<template>
  <div>
    <div @click="back" class="header border-bottom">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div class="content" v-for="item in list" :key="item.id">
      <div class="content-img">
        <img :src="item.imgUrl ? url + item.imgUrl : defaultimg">
        <p>流沙包</p>
      </div>
      <div class="transfer-price">
        <p>转账金额<span>（收取收款方2%手续费）</span></p>
        <div class="content-price border-bottom">
          <span>￥</span>
          <input type="text" v-model="price">
        </div>
        <input class="explain" placeholder="添加转账说明">
      </div>
    </div>
    <div class="footer">
      <button type="submit" @click="handleTransferClick">{{state}}</button>
    </div>
  </div>
</template>

<script>
import url from '@/common/common.js'
export default {
  name: 'TransaccMess',
  props: {
    list: Array
  },
  data () {
    return {
      url,
      state: '转账',
      price: '',
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    handleTransferClick () {
      this.state = '转账中...'
      this.bus.$emit('loading', true)
      this.transferaccount()
      // 反馈
    },
    // 验证
    transferaccount () {
      this.axios.post('http://kukucode.zhinengpingtai.com/apimember/login', {
        price: this.price
      }).then(this.postTranInfoSucc)
        .catch(this.postTranInfoFail)
    },
    // 提交
    postTranInfoSucc (res) {
      alert('禁止操作')
      // this.state = '再次转账'
      // res = res.data
      // if (res.ret && res.okInfo === 'succeed') {
      //   alert('转账成功')
      //   this.$router.push({
      //     path: '/me'
      //   })
      // }
    },
    postTranInfoFail () {
      alert('转账失败')
    }
  }
}
</script>

<style scoped>
.header{ padding: 10px 15px; padding-bottom: 5px;}
.header .iconfont{ font-size: 25px;}
.content{ padding: 20px 15px; padding-top: 25px;}
.content-img{ display: flex; flex-direction: column; align-items: center;}
.content-img img{ width: 60px; height: 60px;}
.content-img p{ color: #b0b0b0;}
.transfer-price span{ color: #999;}
.content-price span{ font-size: 25px; font-weight: bold; color: #333;}
.content-price input{ border: 0; height: 30px; font-size: 20px; padding-bottom: 10px;}
.transfer-price p{ margin: 15px 0;}
.transfer-price .explain{ font-family: Arial,"Microsoft YaHei"; margin-top: 10px; margin-bottom: 0; color: #aca9a9; font-size: 13px;}
input::placeholder{ color: #aca9a9; font-size: 13px;}
.footer a{ text-decoration: none;}
.footer button{ width: 80%; margin-right: auto; margin-left: auto; background-color: #ed2727; color: #fff; display: block; border: 0; height: 40px; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
</style>



// WEBPACK FOOTER //
// src/pages/transfer_accounts/components/Mess.vue